module.exports = __webpack_public_path__ + "img/pay.4f365f6d.png";